import { useLogger } from '~/compositions/logger'
import { ref } from '~/utils/nuxt3-migration'
import useRuntimeConfig from '~/compositions/useRuntimeConfig'

export default function useTurnstile() {
  const loader: any = ref(null)
  const scriptLoaded = ref(false)
  const logger = useLogger()

  const loadTurnstile = (
    widgetElem: HTMLElement,
    callback: Function,
    action?: string,
    onError?: Function
  ) => {
    const {
      public: { turnstileSiteKey }
    } = useRuntimeConfig()

    const renderWidget = () => {
      // @ts-ignore
      window.turnstile.render(widgetElem, {
        sitekey: turnstileSiteKey,
        action,
        theme: 'light',
        callback,
        'error-callback': onError
      })
    }

    if (scriptLoaded.value) {
      renderWidget()
      return
    }

    const loadedScr = document.getElementById('trnstl')
    if (loadedScr) {
      scriptLoaded.value = true
      renderWidget()
      return
    }
    const ld = () => {
      return new Promise<void>((resolve, reject) => {
        const turnstileScript = document.createElement('script')
        turnstileScript.id = 'trnstl'
        turnstileScript.setAttribute(
          'src',
          'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback'
        )
        turnstileScript.defer = true

        // @ts-ignore
        window.onloadTurnstileCallback = () => {
          renderWidget()
          scriptLoaded.value = true
          resolve()
        }
        turnstileScript.onerror = err => reject(err)
        document.head.appendChild(turnstileScript)
      })
    }

    loader.value = ld().catch(e =>
      onError ? onError(e) : logger.captureError(e)
    )
  }

  const removeWidget = () => {
    if (scriptLoaded.value) {
      // @ts-ignore
      window.turnstile.remove()
    }
  }

  return {
    loadTurnstile,
    removeWidget,
    scriptLoaded
  }
}
